import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../api/axiosInstance";
export const fetchMainCategories = createAsyncThunk(
    "category/fetchMainCategories",
    async ({language  }, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.post(
          "/api/Admin/GetMainCategories",
          {},
          {
            headers: {
              "Content-Type": "application/json-patch+json",
              "lang": language === "English" ? "2" : "1",
            },
            
          }
        );
        // Parse the stringified JSON in the 'message' field
        const parsedData = JSON.parse(response.data.message);
        // Return the 'Data' part from the parsed object
        return parsedData.Data;
      } catch (error) {
        console.error("Error fetching main categories:", error);
        return rejectWithValue(error.response?.data || "Error fetching main categories");
      }
    }
  );
  
// MainCategory slice
const mainCategorySlice = createSlice({
  name: "mainCategory",
  initialState: {
    categories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMainCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMainCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.categories = payload;
      })
      .addCase(fetchMainCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
  
});

export default mainCategorySlice.reducer;
